import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { GetResellersFilterLimitsResponse } from "./getResellersFilterLimits.types";

export const requestGetResellersFilterLimits =
  async (): Promise<GetResellersFilterLimitsResponse> => {
    return await instance.get(ApiRoutesResellers.ResellersFilterLimits);
  };
